import { render, staticRenderFns } from "./ForgotPasswordMobile.vue?vue&type=template&id=ced666f6"
import script from "./ForgotPasswordMobile.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports